import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Card, Spin } from 'antd';
import { getOperationById } from '../api/operationsApi';
import GcPagina from '../components/Layout/GcPagina';

const { Text } = Typography;

interface Operation {
  id: number;
  name: string;
  description: string;
}

const OperationDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [operation, setOperation] = useState<Operation | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOperation = async () => {
      if (id) {
        try {
          const data = await getOperationById(parseInt(id));
          setOperation(data);
        } catch (error) {
          console.error('Error loading operation:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    loadOperation();
  }, [id]);

  return (
    <GcPagina
      seccion="Transmisiones"
      titulo="Detalle de Operación"
      volver={{ to: '/transmisiones', etiqueta: 'Volver al listado' }}
    >
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
          <Spin size="large" />
        </div>
      ) : operation ? (
        <Card title={operation.name} bordered>
          <Text>{operation.description}</Text>
        </Card>
      ) : (
        <Card title="Error" bordered>
          <Text>Operación no encontrada</Text>
        </Card>
      )}
    </GcPagina>
  );
};

export default OperationDetailPage;
